"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var rxjs_1 = require("rxjs");
var server = require("superagent");
var SimpleApiClient = /** @class */ (function () {
    function SimpleApiClient() {
        this.agent = server.agent();
    }
    SimpleApiClient.prototype.get = function (url, options) {
        var request = this.agent
            .get(url);
        addCredentials(request, options);
        return getResponse(request);
    };
    SimpleApiClient.prototype.put = function (url, body, options) {
        var request = this.agent
            .put(url)
            .send(body);
        addCredentials(request, options);
        return getResponse(request);
    };
    SimpleApiClient.prototype.post = function (url, body, options) {
        var request = this.agent
            .post(url)
            .send(body);
        addCredentials(request, options);
        return getResponse(request);
    };
    SimpleApiClient.prototype.patch = function (url, body, options) {
        var request = this.agent
            .patch(url)
            .send(body);
        addCredentials(request, options);
        return getResponse(request);
    };
    SimpleApiClient.prototype.delete = function (url, options) {
        var request = this.agent
            .delete(url);
        addCredentials(request, options);
        return getResponse(request);
    };
    return SimpleApiClient;
}());
exports.SimpleApiClient = SimpleApiClient;
function getResponse(request) {
    return rxjs_1.defer(function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, parsedResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, request];
                    case 1:
                        response = _a.sent();
                        parsedResponse = (!!response.body.substr) ? JSON.parse(response.body.toString('utf8')) : response.body;
                        return [2 /*return*/, parsedResponse];
                }
            });
        });
    });
}
function addCredentials(request, options) {
    if (options.withCrendentials) {
        request.withCredentials();
    }
}
//# sourceMappingURL=SimpleApiClient.js.map